function OffenderAlcoholSchedule() {
    "use strict";
    this.__type = 'OffenderAlcoholSchedule:www.veritracks.com';
    this.AppUserId = -1;
    this.EnrolleeId = -1;
    this.EnrolleeTimeZone = "";
    this.ScheduleType = -1;
    this.StartDate = new Date();
    this.StopDate = new Date();
    this.Name = '';
    this.DurationBetweenTest = -1;
    this.TestPerDay = -1;
    this.TestPeriod = -1;
    this.NumberRetest = 1;
    this.MaxNumberRetest = 1;
    this.IsActive = 1;
    this.StatusId = 201;
    this.ConfirmFlag = 0;
    this.Id = -1;
    this.HasOccurred = false;
    this.ExternalId = -1;
    this.Bac = -1;
    this.BacLimit = -1;
    this.ConfirmedDate = new Date();
    this.ConfirmedByUserId = 0;
    this.MaxStartDate = new Date();
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAlcoholSchedule;
}